import { ShieldCheck } from "lucide-react";

const TONE = { Pass: "tp-chip-emerald", Review: "tp-chip-amber", Missing: "tp-chip-rose", "N/A": "" };

export default function IntegrityCard({ rows }) {
  if (!rows?.length) return null;
  return (
    <div className="tp-card p-6 mt-6" data-testid="integrity-card">
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck className="w-4 h-4 text-indigo-500" />
        <div className="font-display font-semibold">Integrity Checks</div>
      </div>
      <div className="divide-y divide-[color:var(--bd-sub)]">
        {rows.map((r, i) => (
          <div key={r.check} className="py-2.5 grid sm:grid-cols-[200px_90px_1fr] gap-x-4 gap-y-1 items-center text-sm" data-testid={`integrity-row-${i}`}>
            <div className="font-medium">{r.check}</div>
            <div><span className={`tp-chip ${TONE[r.status] || ""}`} data-testid={`integrity-status-${i}`}>{r.status}</span></div>
            <div className="text-slate-500">{r.detail}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
